import request, { type ApiResponse, type RequestConfig } from "@/utils/request";

export const getAttachments = (batchId: string, config?: RequestConfig): Promise<ApiResponse<any>> => {
  return request.post('/app/activiti/getDoorFiles', { batchId }, config);
}

// 根据文件 ID 获取预签名 URL (假设接口)
export const getPresignedUrl = (fileUrl: string, download: boolean = false): Promise<ApiResponse<string>> => {
  return request.post('/app/oss/preview-url', { fileUrl, download });
}

export const uploadAttachment = (
  batchId: string,
  doorCode: string,
  taskId: string,
  file: File,
  docType: string,
  name: string,
  fileSource: string,
  extraParams?: { storeDepth?: string | number, storeWidth?: string | number, storeHeight?: string | number }
): Promise<ApiResponse<any>> => {
  const formData = new FormData()
  formData.append('batchId', batchId)
  formData.append('doorCode', doorCode)
  formData.append('taskId', taskId)
  formData.append('file', file)
  formData.append('docType', docType)
  formData.append('name', name)
  formData.append('fileSource', fileSource)

  if (extraParams) {
    if (extraParams.storeDepth !== undefined && extraParams.storeDepth !== null) {
      formData.append('storeDepth', String(extraParams.storeDepth))
    }
    if (extraParams.storeWidth !== undefined && extraParams.storeWidth !== null) {
      formData.append('storeWidth', String(extraParams.storeWidth))
    }
    if (extraParams.storeHeight !== undefined && extraParams.storeHeight !== null) {
      formData.append('storeHeight', String(extraParams.storeHeight))
    }
  }

  return request.post('/app/activiti/upload', formData, {
    headers: {
      'Content-Type': 'multipart/form-data'
    }
  })
}

export const deleteAttachment = (ids: string[]): Promise<ApiResponse<any>> => {
  return request.post('/app/activiti/file/delete', ids);
}

